<template>
    <!-- Start Main Content -->
    <div class="form-container" v-if="invoice">
        <div class="form-header mt-5" style="margin-top:220px;">
          
          <h2 class="form-title">Staff Contract</h2>
        </div>
      
        <div class="section">
            <div class="section-title">Staff Details</div>
            <div class="row">
              <div class="col-50">
                <div class="form-group">
                  <label>Full Name:</label>
                  <p>{{invoice.firstname}} {{invoice.lastname}}</p>
                </div>
                <div class="form-group">
                  <label>Gender:</label>
                  <p>{{invoice.gender}}</p>
                </div>
                <div class="form-group">
                  <label>Contact Number:</label>
                  <p>{{invoice.phonenumber}}</p>
                </div>
              </div>
              <div class="col-50">
                <div class="form-group">
                  <label>Email:</label>
                  <p>{{invoice.email}}</p>
                </div>
                <div class="form-group">
                  <label>Emergency Contact No.:</label>
                  <p>{{invoice.emergencycontact}}</p>
                </div>
                <div class="form-group">
                  <label>Address:</label>
                  <p>{{invoice.address}}</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-50">
                <div class="form-group">
                  <label>Date of Joining:</label>
                  <p>{{invoice.dateofjoining}}</p>
                </div>
              </div>
              <div class="col-50">
                <div class="form-group">
                  <label>Date Of Leaving:</label>
                  <p>{{invoice.dateofleaving}}</p>
                </div>
              </div>
            </div>
          </div>
          
 
      
        <!-- <div class="section">
          <div class="section-title">Staff Details</div>
            <div class="row">
          <div class="col-50">

          </div>
          <div class="col-50">
               <div class="form-group">
                <label>Joining Date:</label>
                <p>{{invoice.startdate}}</p>
              </div>
          <div class="form-group">
            <label>End Date:</label>
            <p>{{invoice.enddate}}</p>
            
          </div>

             
          </div>
          
          </div>
        </div> -->
      
        <div class="section">
          <div class="section-title">Staff Consent</div>
          <p>
    <!-- &nbsp;&nbsp;&nbsp;I, {{invoice.firstname}} {{invoice.lastname}} -->
    <ul>
        <li>•Be present on your duty timing on time; otherwise, late marks will apply.</li>
        <li>•Uniform is compulsory during duty hours.</li>
        <li>•Must use deodorant.</li>
        <li>•Clean indoor training shoes are required at all times.</li>
        <li>•Personal headphones are not permitted during duty.</li>
        <li>•Ignore all distractions while training, including and especially your friends.</li>
        <li>•You should never be sitting on the floor.</li>
        <li>•Respect personal space during exercises and avoid unnecessary physical contact.</li>
        <li>•Teach proper use of equipment and encourage clients.</li>
        <li>•Do not eat anything on the floor.</li>
        <li>•Do not ask members for their contact numbers.</li>
        <li>•Be confident and positive.</li>
        <li>•Kindly use basic human courtesy and politeness.</li>
        <li>•Handle all clients with respect and an attentive nature.</li>
        <li>•Kindly inform management of your leave at least 3 days in advance for confirmation.</li>
        <li>•If a medical emergency occurs, kindly submit your medical documents.</li>
        <li>•A one-month notice period is compulsory if leaving the job.</li>
        <li>All rights regarding promotion and termination are reserved by Fitrium Gym.</li>
    </ul>
    &nbsp;&nbsp;&nbsp;I agree to all the terms and conditions stated above.
</p>

       <br>
          <div class="form-group">
            <label>Staff Name:</label>
            <p>{{invoice.firstname}} {{invoice.lastname}}</p>
          </div>

          <br>
          <div class="form-group">
            <label>Staff Signature:</label>
            <p></p>
          </div>
        </div>
  <!--      <div class="section">-->
  <!--        <div class="section-title">MANAGEMENT DISCLAIMER</div>-->
  <!--        <p>-->
            
  <!--1. The management reserves the right to admission.<br>-->
  <!--2. Memberships are non-proprietary. No representations, written or oral, other than those contained in the rules are authorized by or binding upon the fitness club.<br>-->
  <!--3. The management may at anytime modify timings of the fitness club. Intimation of any modifications and holidays will be made available to members through messages on the notice board.We reserve the prerogative to assume that all members read the notice board.<br>-->
  <!--4. The management may introduce, discontinue or modify any facility, service, equipment, rules and regulations or rates of the fitness club without prior notice.<br>-->
  <!--5. The management shall not be considered in default of its-->
  <!--obligations in the instance of natural calamities such as floods, earthquakes, tomadoes, hurricanes, storms and heavy rainfall as well as occurrences such as strikes, lockdown,war, riots or fire, etc. In case of such unforeseen exceptional circumstances, the management may also be forced to discontinue operations temporarily or permanently. Under such circumstances the management will not be liable to pay any refund or give any extension.<br>-->
  <!--6. The fitness clubs participating in collateral membership, intra club transfer facility and loyalty program may change from time to time at the sole discretion of the management and without prior notice. On request, information of these changes will be available to members at the front desk.<br>-->
  <!--7. The management will not be responsible for any personal injuries or accidents sustained by individuals in and around the premises. Individuals may use all the facilities at their own risk.<br>-->
  <!--8. Members are responsible for their own belongings and are advised not to carry valuables to the club. The management will not be responsible for any loss or theft of personal belongings of members.<br>-->
  <!--9. Members must not keep their personal belongings or locker keys with any staff member in the club. The management will not be responsible for any theft or loss resulting from such actions.<br>-->
  <!--10. Parking/valet parking in and around the club premises is at the sole responsibility of members.<br>-->
  <!--11. Membership fees and all other additional facility payments-->
  <!--collected including registration fees are non-refundable. We have a 'No Refund' policy.<br>-->
  <!--12. Members must make all payments only at the front desk and in exchange for a valid receipt. Members are advised to retain that receipt for the entire duration of their membership. No disputes or arguments will be entertained without presenting a valid receipt. <br>-->
  <!--13. Payment towards membership or services at the fitness club ensures the member the use of that service or membership for the duration bought as per the rules. The payment in no way guarantees the same staff throughout the period of usage of the service or membership. Change in staff does not entitle any member to a refund.<br>-->
  <!--14. Memberships of those members not abiding by the rules or defaulting in any payment will be terminated without a refund.<br> -->
  <!--15. Members must not carry or store any illegal items or arms and ammunitions in the club premises. The management will not be responsible for such actions.<br>-->
  <!--16. We assume that members have read all rules and regulations governing the operations of the club.<br>-->
  <!--17. Refrain from using abusive language, fighting or treating anyone disrespectfully. If a member is found treating anyone disrespectfully or whose actions are in any way detrimental or hurtful to the sentiments of other members or staff, the management may at its discretion, suspend or cancel the rights, privileges or membership of that individual without refunding the fees.<br>-->
  <!--18. Smoking, consuming alcohol and chewing of beetle leaf or tobacco in the premises is strictly prohibited. Entering the fitness club premises under the influence of alcohol or any recreational drugs is strictly prohibited. If a member is found breaking this rule, the management may at its discretion, suspend or cancel the rights, privileges or membership of that individual without refunding the fees.<br>-->
  <!--FITNESS AREA RULES-->
  <!--1. Sportswear is compulsory in the workout areas of the club. Clothing considered inappropriate by the management will be-->
  <!--prohibited.<br>-->
  <!--2. Appropriate and clean sports footwear is mandatory in the workout areas of the club.<br>-->
  <!--3. No food or drinks are allowed in the exercise areas with the exception of covered bottles.<br>-->
  <!--4. Bags and other personal belongings must be left outside the exercise area and neatly kept in the changing rooms or the lockers provided.<br>-->
  <!--5. Television sets are provided only for visual entertainment and they will be kept on mute at all times.<br>-->
  <!--6. Members are advised not to carry mobile phones and other valuables on the workout areas and if they do, they do so at their own risk.<br>-->
  <!--7. All members are requested to carry their exercise schedule cards and duly fill the same during their workouts. These must be put in the appropriate slot in the holder after use. Put the cards according to the 1st letter of your last name.<br>-->
  <!--8. Weights must be handled with care and careless dropping of weights is prohibited. Repeated offences will lead to termination of membership without a refund.<br>-->
  <!--9. Please allow our trainers to focus on their prime purpose - To correct your exercise technique and to motivate you .We request you to rack all weights back on the stands after use.<br>-->
  <!--10. If a piece of equipment is malfunctioning, members must discontinue use and notify staff immediately.<br>-->
  <!--11. The management reserves the right to stop any activity that may be hazardous to the safety of other members e.g. skipping-->
  <!--etc.<br>-->
  <!--12. Members are requested to not ask for help from a staff member wearing a Personal training tag as this signifies that he/she is busy with Personal training.<br>-->
  <!--13. To benefit maximum members, the workout area is divided into zones and separate trainers are allotted to each zone. Trainers may be moved from one zone to another at the discretion of the floor supervisor.<br>-->
  <!--14. Members are requested to inform any staff member in case they experience any discomfort such as dizziness, pain, excessive sweating, shortness of breath, etc. immediately. A comprehensive first aid kit is available at the front desk. <br>-->
  <!--15. In case there is a waiting list maintained for the use of cardio machines, members who put their names on the waiting list are requested to note that when their turn comes, the receptionist will wait for the member to avail his/her turn for a limited period of 2 minutes only. After the 2 minute waiting period the turn will be given to the next member in line. The member who has missed his/her turn will have to put his/her name again at the bottom of the list.<br>-->
  <!--16. In order to maintain hygiene, it is compulsory to carry a napkin or a towel while working out. All equipment must be wiped clean after use.<br>-->
  <!--17. Chalk for securing grip on free weights is not permitted. Locks on barbells must be used at all times.<br>-->
  <!--18. All guidelines and directions provided by the trainers for use of equipment must be adhered to.<br>-->
  <!--19. Members must stop or pause the treadmill before getting off even if it is for a short while.<br>-->
  <!--20. Maximum time limit set by management for using cardio equipment must be strictly adhered to.<br>-->
  <!--21. The temperature within the premises and the volume and type of music played would be maintained as per majority preference at the sole discretion of the management.<br>-->
  
  <!--        </p>-->
  <!--        <div class="form-group">-->
  <!--          <label>Member's Signature:</label>-->
  <!--          <p></p>-->
  <!--        </div>-->
  <!--        <div class="form-group">-->
  <!--          <label>Date:</label>-->
  <!--          <p></p>-->
  <!--        </div>-->
  <!--      </div>-->
        <div class="footer">
          <p>&copy; FITRIUM GYM. All rights reserved.</p>
        </div>
      </div>


    


</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'AddProduct',
components: {
 
} ,
mounted(){
    const memberId = this.$route.query.id; // Retrieve the query parameter
    this.fetchInvoice(memberId);
},
data() {
 return {
     staffList:[],
     attendance: [],
    invoice:null,
 }
 }, 
methods:{
    fetchInvoice(staffId) {
      axios.post(`/staffinvoice/details/${staffId}`)
        .then(response => {
          this.invoice = response.data;

          // Wait for DOM update and trigger print
          this.$nextTick(() => {
            window.print();
          });
        })
        .catch(error => {
          console.error('Error fetching invoice:', error);
        });
    },
  
  

            
}
}
</script>
<style scoped>
    * {
    box-sizing: border-box;
    font-family: Arial, sans-serif;
  }

  body {
    background-color: #f3f3f3;
    padding: 20px;
  }

  .form-container {
    width: 800px;
    margin: auto;
    background-color: #fff;
    
    padding: 20px;
  }

  .form-header {
    text-align: center;
    margin-bottom: 20px;
  }

  .form-header img {
    width: 100px;
    margin-bottom: 10px;
  }

  .form-title {
    font-weight: bold;
    font-size: 24px;
    margin: 0;
  }

  .section {
    margin-bottom: 15px;
  }

  .section-title {
    font-weight: bold;
    font-size: 18px;
    background-color: #000;
    color: #fff;
    padding: 5px;
    margin-bottom: 2px;
  }

  .form-group {
    display: flex;
    align-items: center;
    margin-bottom: 2px;
  }

  
  .form-groups {
    display: flex;
    align-items: center;
    margin-top: 3px;
  }


  .form-group label {
    flex: 0 0 200px;
    font-weight: bold;
  }

  .form-group input {
    flex: 1;
    padding: 5px;
    border: 1px solid #ddd;
  }

  .row {
    display: flex;
    flex-wrap: wrap;
  }

  .col-50 {
    width: 50%;
    padding: 0 10px;
  }

  .col-100 {
    width: 100%;
  }

  .footer {
    text-align: center;
    margin-top: 20px;
  }
    </style>